"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M5 18c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1m12 0c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1m-9 4c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1m3-4c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1m3 4c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1m3.5-6h-10C4.47 16 2 13.53 2 10.5c0-2.76 2.09-5.09 4.78-5.44C7.83 3.18 9.82 2 12 2c2.97 0 5.45 2.18 5.92 5.02C20.21 7.23 22 9.16 22 11.5c0 2.48-2.02 4.5-4.5 4.5"
}), 'CloudySnowing');